import types from './types';
import {dispatchAsync} from 'redux/common';
import api from 'api';
import ApiService from 'api/ApiService';
import {downloadTextFile, getFileName} from 'common/downloadFile';

const downloadConnectionAuditReport = () =>
   dispatchAsync(api.connectionauditReport, types.DOWNLOAD_CONNECTION_AUDIT_REPORT, {
      getMethod: ApiService.postSecureJson,
      data: {},
      onSuccess: async (data?, dispatch?, res?) => {
         // const blob = await res.text();
         // console.debug('downloadConnectionAuditReport res', data, res);
         const fName = getFileName(res!) || 'connectionAudtiReport.html';
         downloadTextFile(data, fName);
      },
   });

export default {
   downloadConnectionAuditReport,
};
